/* eslint-disable import/no-extraneous-dependencies */
import { Button } from '@wisecare-tech/design-system-web';
import errorIllustration from 'presentation/base/images/system-error-illustration.png';
import { translator } from 'presentation/components/i18n';
import React from 'react';
import {
  Container,
  Description,
  Illustration,
  LeftPanel,
  RightPanel,
  TextContent,
  Title,
} from './styles/matchErrorStyles';

const MatchError: React.FC = () => {
  const handleReload = (): void => {
    window.location.reload();
  };

  return (
    <Container>
      <LeftPanel>
        <TextContent>
          <Title>
            {translator(
              'Não foi possível estabelecer a conexão com o sistema.',
            )}
          </Title>
          <Description>
            {translator(
              'Em breve o acesso será restabelecido.\nPor favor, tente novamente em alguns minutos.\nAgradecemos sua compreensão.',
            )}
          </Description>
        </TextContent>
        <Button variant="primary" size="md" onClick={handleReload}>
          {translator('Recarregar página')}
        </Button>
      </LeftPanel>
      <RightPanel>
        <Illustration
          src={errorIllustration}
          alt={translator('Estamos realizando melhorias no sistema.')}
        />
      </RightPanel>
    </Container>
  );
};

export default MatchError;
